// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* overridden by src/lib/themes/guiHelpers.js */

.share-button_share-button_c_HWq {
    background: var(--data-primary);
}

.share-button_share-button-is-disabled_KvHSV {
    background: var(--ui-black-transparent);
    cursor: default;
}

.share-button_spinner_Np9tZ {
    vertical-align: middle;
}
`, "",{"version":3,"sources":["webpack://./src/components/menu-bar/share-button.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;IACI,+BAA+B;AACnC;;AAEA;IACI,uCAAuC;IACvC,eAAe;AACnB;;AAEA;IACI,sBAAsB;AAC1B","sourcesContent":["/* overridden by src/lib/themes/guiHelpers.js */\n\n.share-button {\n    background: var(--data-primary);\n}\n\n.share-button-is-disabled {\n    background: var(--ui-black-transparent);\n    cursor: default;\n}\n\n.spinner {\n    vertical-align: middle;\n}\n"],"sourceRoot":""}]);
// Exports
var _1 = `share-button_share-button_c_HWq`;
export { _1 as "share-button" };
export var shareButton = `share-button_share-button_c_HWq`;
var _2 = `share-button_share-button-is-disabled_KvHSV`;
export { _2 as "share-button-is-disabled" };
export var shareButtonIsDisabled = `share-button_share-button-is-disabled_KvHSV`;
export var spinner = `share-button_spinner_Np9tZ`;
export default ___CSS_LOADER_EXPORT___;
